var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.5C3.75 5.84531 5.09531 4.5 6.75 4.5H8.25C9.90469 4.5 11.25 5.84531 11.25 7.5V7.66875C11.25 8.69063 10.7297 9.64219 9.87188 10.1906L7.89375 11.4609C7.31295 11.8344 6.83521 12.3477 6.50433 12.9537C6.17346 13.5598 6.00005 14.2392 6 14.9297V15C6 15.8297 6.67031 16.5 7.5 16.5C8.32969 16.5 9 15.8297 9 15V14.9344C9 14.55 9.19687 14.1937 9.51562 13.9875L11.4937 12.7172C13.2094 11.6109 14.25 9.7125 14.25 7.66875V7.5C14.25 4.18594 11.5641 1.5 8.25 1.5H6.75C3.43594 1.5 0.75 4.18594 0.75 7.5C0.75 8.32969 1.42031 9 2.25 9C3.07969 9 3.75 8.32969 3.75 7.5ZM7.5 22.5C7.99728 22.5 8.47419 22.3025 8.82583 21.9508C9.17746 21.5992 9.375 21.1223 9.375 20.625C9.375 20.1277 9.17746 19.6508 8.82583 19.2992C8.47419 18.9475 7.99728 18.75 7.5 18.75C7.00272 18.75 6.52581 18.9475 6.17417 19.2992C5.82254 19.6508 5.625 20.1277 5.625 20.625C5.625 21.1223 5.82254 21.5992 6.17417 21.9508C6.52581 22.3025 7.00272 22.5 7.5 22.5Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.704637f2e91c24c9d319b59016c644bb.svg";
export { ForwardRef as ReactComponent };